<template>
  <div class="truck-sighting slide">
    <VerticalAnimation :animation="animation" :background="background" :loop=false />
    <div class="vertical-layout animated fadeIn delay-2s">
      <p class="store">Pawn Shop</p>
      <h1>Orange Pickup</h1>
      <p>After 2 days of static surveillance, investigators take note of an orange pickup frequenting the shop. They decide to run the vehicle’s tags.</p>
    </div>
    <router-link to="/yarnboard-4">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import VerticalAnimation from '@/components/VerticalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import Truck from '@/assets/truck2.js'
import VerticalImage from '@/assets/orange-pickup-bg@2x.png'

export default {
  name: 'truck-sighting',
  components: {
    VerticalAnimation,
    NextButton
  },
  data() {
    return {
      animation: Truck,
      background: VerticalImage
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .vertical-layout {
      top: 25%;
      width: 78%;
    }
</style>
